import { render } from "./Schedule.vue?vue&type=template&id=2f5196eb"
import script from "./Schedule.vue?vue&type=script&lang=js"
export * from "./Schedule.vue?vue&type=script&lang=js"

import "./Schedule.vue?vue&type=style&index=0&id=2f5196eb&lang=css"
script.render = render

export default script